export const SUPPORTED_LOCALES = ['fr-FR', 'en-US'] as const;

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export function getBrowserLocale(): SupportedLocale {
  const locale = ((typeof navigator !== 'undefined' && navigator.language) || 'fr-FR').toLowerCase();
  return locale.startsWith('en') ? 'en-US' : 'fr-FR';
}

export function getDateFormatForLocale(locale: SupportedLocale): string {
  return locale === 'en-US' ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
}
